module.exports = __webpack_public_path__ + "img/indian-rupee.b5204011.png";